function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M870.11,389.63c2.2-110.83-9.08-241.51-70.85-328.85-70-98.92-185.5-54-270.58-3C509,69.55,493.86,77.59,474.81,90.25c-72.37,48.07-164.35,47.42-243.33,16.24-21-8.27-41-18.88-62.21-26.52C115.64,60.63,56.89,61,.22,67.27",
  fill: "none",
  stroke: "#1d1d1d",
  strokeWidth: 4,
  opacity: 0
});

var SvgCoverSquiggle1 = function SvgCoverSquiggle1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "be0b54ed-2f30-47c8-84ae-a93679a1d80d",
    "data-name": "Layer 1",
    width: 872.36,
    height: 389.67,
    viewBox: "0 0 872.36 389.67",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoverSquiggle1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cover-squiggle-1.3e59d7fd.svg";
export { ForwardRef as ReactComponent };